import { PermisoMenuDto } from "./permiso-menu-dto"
export class Sesion {
  nombreUsuario: string;
	usuario: string;
	ultimoAcceso: string;
  urlLogOut: string;
  permisoMenuDto: PermisoMenuDto;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/sesion.ts